import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TestQueryService {
  newData:any = {}
  rootIp:any;
  bgColor:any = "light";
  saveDashboard:any;
  publishDashboard:any;
  
  constructor(private sanitizer:DomSanitizer) { }
  setId(res:any){
    this.newData = res;
  }
    // 创建图形
}

